exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.edar_card-notice[data-v-6f3d22af] {\n    width: 5rem;\n    min-width: -webkit-fit-content;\n    min-width: -moz-fit-content;\n    min-width: fit-content;\n    margin-right: 0.5rem;\n}\n.edar_card-data[data-v-6f3d22af] {\n    max-width: 100%;\n}\n", ""]);

// exports
